import React, { FC, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import ButtonClose from "shared/ButtonClose/ButtonClose";

export interface ModalProps {
    isOpen: boolean;
    closeButton?: () => void;
    children?: any
}

const Modal: FC<ModalProps> = ({
    isOpen,
    children,
    closeButton = null
}) => {

    const renderModal = () => {
        return (
            <Transition
                appear
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                show={isOpen}
                as={Fragment}
            >
                <Dialog
                    as="div"
                    className="fixed inset-0 z-50 overflow-y-auto"
                    onClose={() => console.log("")}
                >
                    <div className="h-5/6 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-gray-200" />
                        </Transition.Child>
                        {closeButton !== null &&
                            <div className="absolute left-2 top-2 md:top-4 md:left-4">
                                <ButtonClose onClick={closeButton} className=" w-11 h-11" />
                            </div>
                        }
                        <span
                            className="inline-block h-screen align-middle"
                            aria-hidden="true"
                        >
                            &#8203;
                        </span>
                        <div className="relative inline-block max-w-5xl my-8 align-middle justify-center ">
                            {children()}
                        </div>

                    </div>
                </Dialog>
            </Transition>
        );
    };

    return renderModal();
};

export default Modal;
